module.exports = __webpack_public_path__ + "static/img/dopay.82eb22f0.svg";